<template>
  <div v-if="isInitialized">
    <span class="ndfe-auth--account-button">
      <a
        v-if="loggedUser"
        class="primary--text text-cursor-pointer"
        :title="$t('AUTH.REGISTER.LOGOUT')"
        @click.prevent="logout"
      >
        {{ $t('AUTH.REGISTER.LOGOUT') }}
      </a>
      <template v-else>
        <a
          v-if="showRegister"
          class="primary--text text-cursor-pointer"
          :title="$t('AUTH.REGISTER.CREATE_ACCOUNT')"
          @click.prevent="openLoginDialog('signUp')"
        >
          {{ $t('AUTH.REGISTER.CREATE_ACCOUNT') }}
        </a>
        <span
          v-if="showRegister"
          class="mx-1"
        >
          {{ $t('AUTH.REGISTER.OR') }}
        </span>
        <a
          class="primary--text text-cursor-pointer"
          href="#"
          :title="$t('AUTH.REGISTER.LOGIN')"
          @click.prevent="openLoginDialog('signIn')"
        >
          {{ $t('AUTH.REGISTER.LOGIN') }}
        </a>
      </template>
    </span>
    <LoginDialog
      v-if="dialogVisible"
      v-model="dialogVisible"
      :max-width="showRegister ? 860 : 430"
      :show-register="showRegister"
      :tab-active="tabActive"
      :title="dialogTitle"
      :subtitle="dialogSubtitle"
      @closeDialog="dialogVisible = false"
    />
  </div>
</template>

<script>
export default {
  name: 'AuthAccountButton',
  isCustomElement: true,
  components: {
    LoginDialog: () => import(/* webpackChunkName: "LoginDialog" */ './LoginDialog.vue').then((d) => d.default),
  },
  props: {
    showRegister: {
      type: Boolean,
      default: true,
    },
  },
  data: () => ({
    modules: ['auth'],
    dialogVisible: false,
    tabActive: 'signIn',
  }),
  computed: {
    isInitialized() {
      return this.state('auth.initialized');
    },
    loggedUser() {
      return this.getters('auth/isUserLogged');
    },
    dialogTitle() {
      return this.showRegister ? '' : this.$t('AUTH.LOGIN.LOG_IN');
    },
    dialogSubtitle() {
      return this.showRegister ? '' : this.$t('AUTH.LOGIN.LOG_INTO_YOUR_ACCOUNT');
    },
  },
  methods: {
    logout() {
      this.dispatch('auth/logout');
    },
    openLoginDialog(tabActive = 'signIn') {
      this.tabActive = tabActive;
      this.dialogVisible = true;
    },
    afterModulesLoaded() {
      // load auth0 script to check if it has logged in user
      this.dispatch('auth/checkToLoadScript');
    },
  },
};
</script>

<style lang="scss" scoped>
.ndfe-auth--account-button {
  a {
    text-decoration: none;
  }
}
</style>
